import { checkedBg, checkedBorder, focusVisible } from "../../Resources/CSS/styling"

  
  export default function Radio({ options, selected, onChange, name, direction = "flex-row"}) {
    return (
      <fieldset>
        <div className={`space-${direction === "flex-row" ? "x" : "y"}-4 flex mt-2 ${direction}`}>
          {options.map((option) => (
            <div key={option.id} className="flex items-center">
              <input
                id={option.id}
                name={name}
                type="radio"
                checked={option.id === selected.id}
                className={`relative size-4 appearance-none rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full before:bg-white ${checkedBorder} ${checkedBg} focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${focusVisible} disabled:border-gray-300 disabled:bg-gray-100 disabled:before:bg-gray-400 forced-colors:appearance-auto forced-colors:before:hidden [&:not(:checked)]:before:hidden`}
                onChange={() => onChange(option.id)}
              />
              <label htmlFor={option.id} className="ml-3 block text-sm/6 font-medium text-gray-900">
                {option.name}
              </label>
            </div>
          ))}
        </div>
      </fieldset>
    )
  }
  